import { Helmet } from "react-helmet";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./Section3";
import Section4 from "./Section4";
import Section5 from "./Section5";
import Section6 from "./Section6";
import Section7 from "./Section7";
import Section8 from "./Section8";
import Section9 from "./Section9";
import Section10 from "./Section10";
import Section11 from "./Section11";
import Section12 from "./Section12";
import Section13 from "./Section13";
import Section14 from "./Section14";
import Section15 from "./Section15";
import Section16 from "./Section16";
import Section17 from "./Section17";
import Section18 from "./Section18";

export default function MobileAppDevelopment() {
  return (
    <div className="Mobile-App-Development pt-[160px] sm:pt-0">
      <Helmet>
      <title>Mobile App Development Services | Custom Android & iOS Apps</title>
        <meta
        name="description"
        content="Build scalable mobile apps with Mean3. We offer mobile app development for Android, iOS, and cross-platform solutions to help your business grow."
      />
      </Helmet>
      <Section1 />
      {/* <Section2 />
      <Section3 /> */}
      <Section5 />
      <Section6 />
      <Section7 />
      <Section8 />
      <Section9 />
      <Section10 />
      <Section11 />
      <Section12 />
      <Section13 />
      <Section14 />
      <Section15 />
      <Section16 />
      <Section17 />
      <Section18 />
      <Section4 />
    </div>
  );
}
